module.exports = __webpack_public_path__ + "static/home3b-6bcd04b0f21ee7fa2d6d0fd608aa4b9c.jpg";